import { Redirect, Switch } from 'react-router'

import { ProtectedRoute } from '@webapp/app/components'
import { useModuleConfig } from '@webapp/app/config/useModuleConfig'
import { useAppRoutes } from '@webapp/hooks'
import {
  BudgetCategoryCreatePage,
  BudgetCategoryEditPage,
  BudgetCategoryPage,
} from '@webapp/pages'

export const BudgetCategoryManagementRouter = () => {
  const { url, brp } = useAppRoutes()

  const {
    routes: { enableBudgetRoutes },
  } = useModuleConfig()

  if (!enableBudgetRoutes) return <Redirect to={url('DashboardPage')} />

  return (
    <Switch>
      <ProtectedRoute
        exact
        path={brp('BudgetCategoryPage')}
        render={() => <BudgetCategoryPage />}
      />
      <ProtectedRoute
        exact
        path={'/settings/budget-categories'}
        render={() => <Redirect to={brp('BudgetsPage')} />}
        featureSwitches={['enable_flexible_spend_tracking']}
      />

      <ProtectedRoute
        path={brp('BudgetCategoryCreatePage')}
        render={() => <BudgetCategoryCreatePage />}
      />
      <ProtectedRoute
        exact
        path={'/settings/budget-categories/create'}
        render={() => <Redirect to={brp('BudgetsCreatePage')} />}
        featureSwitches={['enable_flexible_spend_tracking']}
      />

      <ProtectedRoute
        path={brp('BudgetCategoryEditPage', { uuid: `:uuid` })}
        render={() => <BudgetCategoryEditPage />}
      />
      <ProtectedRoute
        path={`/settings/budget-categories/edit/:uuid`}
        render={() => (
          <Redirect to={brp('BudgetsEditPage', { uuid: ':uuid' })} />
        )}
        featureSwitches={['enable_flexible_spend_tracking']}
      />
    </Switch>
  )
}
